import { BACKEND_URL } from "../config";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const getTax = (countryCode: string | null) => {
    let url = `${BACKEND_URL}/api/v1/tax`;
    if (countryCode) {
        url += `/${countryCode}`;
    }
    return axios.request(
        {
            url: url,
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            method: "GET",
        }
    )
}

export const useGetTax = (countryCode: string | null = null) => {
    return useQuery({
        queryKey: ["tax", countryCode],
        queryFn: async () => {
            const response = await getTax(countryCode);
            return response.data;
        },
        retry: 1
    });
}